import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import moment from 'jalali-moment';

const MySwal = withReactContent(Swal);

const NewResumes = () => {
  const [resumes, setResumes] = useState([]);
  useEffect(() => {
    axios
      .get('https://arianaapp.arianaapply.com/panel/show-new-resume')
      .then((res) => {
        console.log(res);
        setResumes(res.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const changeFlag = (id) => {
    axios
      .get(`https://arianaapp.arianaapply.com/panel/change-flag-for-new-resume/${id}`)
      .then((res) => {
        console.log(res);
        MySwal.fire({
          title: 'با موفقیت ثبت شد',
          icon: 'success',
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload(false);
          }
        });
      }).catch(err => console.log(err));
  };
  return (
    <div className='index'>
      <div className='table'>
        <table>
          <thead>
            <tr>
              <td>نام</td>
              <td>شهر</td>
              <td>ایمیل</td>
              <td>جنسیت</td>
              <td>زبان</td>
              <td>سن</td>
              <td>تاهل</td>
              <td>شماره تماس</td>
              <td>تاریخ</td>
              <td>عملیات</td>
            </tr>
          </thead>
          <tbody>
            {resumes?.reverse().map((res) => (
              <tr key={res._id}>
                <td>{res.name}</td>
                <td>{res.city}</td>
                <td>{res.email}</td>
                <td>{res.gender}</td>
                <td>{res.language}</td>
                <td>{res.age}</td>
                <td>{res.maritalStatus}</td>
                <td>{res.phone}</td>
                <td>
                      {
                        moment(res.created_at, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('YYYY/MM/DD')
                      }
                    </td>
                <td>
                  <button className='success' onClick={() => changeFlag(res._id)}>
                    <FontAwesomeIcon icon={faEye} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NewResumes;
